import { KYMW0400Model } from '../kymw0400.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * 取引先一覧画面　取引先一覧を取得するサービス
 *
 * @export GetSupplierListService
 * @class GetSupplierListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSupplierListService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0400Model}
   * @memberof GetSupplierListService
   */
  private model: KYMW0400Model;

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetSupplierListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSupplierListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        SearchKana: this.model.searchKana
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSupplierListService
   */
  execute(model: any, successFunc: Function): void {
    this.model = <KYMW0400Model>model;
    this.successFunc = successFunc;
    this.send('getSupplierList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSupplierListService
   */
  success(data: any): void {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
